var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeNot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28531 10C1.33861 8.90479 1 8 1 8C1 8 3.54545 3 8 3C8.34487 3 8.67831 3.02997 9 3.08527M7 12.9147C7.32169 12.97 7.65513 13 8 13C12.4545 13 15 8 15 8C15 8 14.824 7.14829 13.7553 6",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3468 10.9287C7.55708 10.9754 7.77566 11 8 11C9.65685 11 11 9.65685 11 8C11 7.77566 10.9754 7.55708 10.9287 7.3468L7.3468 10.9287ZM8.67399 5.07601C8.45734 5.02628 8.23174 5 8 5C6.34315 5 5 6.34315 5 8C5 8.23174 5.02628 8.45734 5.07601 8.67399L8.67399 5.07601Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1L1 15",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeNot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-not.a6ac5a526f90aca6a01a173043c5fd96.svg";